<template>
    <div class="table-notes-title" v-bind:style="headerStyle">
        <div class="text-truncate t-header" v-if="headerTitle">{{ headerTitle }}</div>
        <div class="btn-group btn-group-sm float-sm-right" role="group" aria-label="Table options">
            <!-- ADD BUTTON -->
            <template v-if="$parentInstance.showAdd">
                <b-tooltip
                    v-if="addAction.tooltip"
                    :target="'add-action-button'"
                    placement="top"
                    :delay="{ show: 1500, hide: 50 }"
                >
                    {{ addAction.tooltip }}
                </b-tooltip>
                <b-button
                    id="add-action-button"
                    class="table-title-btn"
                    @click="addHandler"
                    :disabled="addButtonDisabled"
                >
                    {{ $t('Shared.Add') }}
                </b-button>
            </template>

            <!-- EDIT SELECTED BUTTON -->
            <template v-if="$parentInstance.showBulkEdit">
                <b-tooltip
                    target="edit-selected-button"
                    placement="top"
                    :delay="{ show: 1500, hide: 50 }"
                >
                    {{ $t('Shared.Edit') }}
                </b-tooltip>
                <b-button
                    id="edit-selected-button"
                    class="table-title-btn"
                    @click="$parentInstance.openBulkEdit()"
                    :disabled="editSelectedDisabled"
                >
                    {{ $t('Shared.Edit') }}
                </b-button>
            </template>

            <!-- DELETE BUTTON -->
            <template v-if="$parentInstance.showDelete">
                <b-tooltip
                    :target="'delete-action-button'"
                    placement="top"
                    :delay="{ show: 1500, hide: 50 }"
                >
                    {{ $t('Shared.Delete') }}
                </b-tooltip>
                <b-button
                    id="delete-action-button"
                    class="table-title-btn"
                    @click="deleteHandler"
                    :disabled="deleteButtonDisabled"
                >
                    {{ $t('Shared.Delete') }}
                </b-button>
            </template>
        </div>
    </div>
</template>

<script>
import Utils from '@/common/utils';

export default {
    name: 'EditableToolbar',
    inject: ['$parentInstance'],
    props: {
        headerTitle: {
            type: String,
            default: null
        },
        headerStyle: {
            type: String,
            default: ''
        }
    },
    computed: {
        addAction() {
            return {
                tooltip: this.$t('Shared.Add'),
                ...this.$parentInstance.addActionButton
            };
        },
        addButtonDisabled() {
            return false;
        },
        editSelectedDisabled() {
            return this.$parentInstance.d_selected_rows.length === 0;
        },
        deleteButtonDisabled() {
            return this.$parentInstance.d_selected_rows.length === 0;
        }
    },
    methods: {
        async addHandler() {
            // Auto-commit any pending row before opening a new one
            if (this.$parentInstance.d_new_rows.length > 0) {
                const committed = await this.$parentInstance.saveNewRows();
                if (!committed) {
                    return; // pending row has validation errors — user must fix first
                }
            }

            let newRow = this.createNewRow();

            if (this.addAction.handler) {
                const handlerResult = this.addAction.handler();
                newRow = Utils.mergeWithPriority(newRow, handlerResult);
            }

            this.$parentInstance.d_new_rows.unshift(newRow);
        },

        createNewRow() {
            const newRow = {};
            this.$parentInstance.columns.forEach(element => {
                newRow[element.key] = element.defaultValue ? element.defaultValue : null;
            });
            return newRow;
        },

        deleteHandler() {
            const selected = this.$parentInstance.d_selected_rows;
            if (selected.length > 0 && this.$parentInstance.deleteActionButton.handler) {
                this.$parentInstance.deleteActionButton.handler(selected[0]);
            }
        }
    }
};
</script>
